// The Car Collector Studio logo (from the logo kit in public/brand/web).
//  variant="white": always the white logo, for surfaces that are always dark (sidebar, top bar).
//  variant="auto":  white logo on the dark theme, dark logo on the light theme.
const ALT = 'Car Collector Studio';

export const BrandLogo = ({ width = 200, variant = 'auto', className = '', style }) => {
  const base = { display: 'block', width, height: 'auto', maxWidth: '100%', ...style };
  if (variant === 'white') {
    return <img className={`brand-logo ${className}`} src="/brand/web/logo-white-640.png" alt={ALT} style={base} />;
  }
  return (
    <>
      <img className={`brand-logo brand-logo-ondark ${className}`} src="/brand/web/logo-white-640.png" alt={ALT} style={base} />
      <img className={`brand-logo brand-logo-onlight ${className}`} src="/brand/web/logo-dark-640.png" alt={ALT} style={base} />
    </>
  );
};
